import { CustomerDocuments } from "./CustomerDocument";

export interface Customer {
    id: string;
    name: string;
    rfc: string;
    tax_id?: string;
    external_id?: string;
    country: string;
    status: string;
    classifications?: string[];
    currencies?: string[];
    documents?: CustomerDocuments;
    created_at: Date;
    signins?: number;
    all_signins?: number;
    invoices?: number;
}

export interface Customers {
    items: Customer[];
    total: number;
    classifications?: string[];
}

export interface CustomersQueryParams {
    search: string;
    classification?: string;
    status?: string;
    documents_status?: string;
    sort_by?: "DOCUMENTS_STATUS" | "USE";
    with_signins?: boolean;
}

export interface CustomerRequest {
    name: string;
    rfc: string;
    tax_id?: string;
    external_id?: string;
    country: string;
    enabled: boolean;
    currencies: string[];
}

export interface CustomerImportSummaryResponse {
    found: number;
    created: number;
    duplicated: number;
    failed: number;
    active: number;
    inactive: number;
}

export interface CustomerExportResponse {
    total: number;
    url?: string;
}

export interface CustomerUpdateClassificationsRequest {
    customers: string[],
    append: string[],
    remove: string[]
}

export interface CustomerClassificationsResponse {
    classifications: string[];
}

export interface CustomerUpdateClassificationsResponse extends CustomerClassificationsResponse {
    updated: number;
}

export const CustomerStatus = ["ENABLED", "DISABLED"];

export const ALLOWED_CURRENCIES = ["MXN", "USD", "EUR"];